export const recentPurchases = [
  { name: 'Laura G.', city: 'Bogotá', product: 'MegaPack + Plan Maestro', time: 'hace 2 minutos' },
  { name: 'Andrés M.', city: 'Medellín', product: 'MegaPack Colon Tranquilo', time: 'hace 4 minutos' },
  { name: 'Paola R.', city: 'Cali', product: 'MegaPack + Plan Maestro', time: 'hace 6 minutos' },
  { name: 'Camilo T.', city: 'Barranquilla', product: 'MegaPack Colon Tranquilo', time: 'hace 9 minutos' },
  { name: 'Natalia V.', city: 'Bucaramanga', product: 'MegaPack + Plan Maestro', time: 'hace 11 minutos' },
  { name: 'Felipe C.', city: 'Pereira', product: 'MegaPack Colon Tranquilo', time: 'hace 14 minutos' },
  { name: 'Valentina S.', city: 'Cartagena', product: 'MegaPack + Plan Maestro', time: 'hace 17 minutos' },
  { name: 'Jorge H.', city: 'Manizales', product: 'MegaPack Colon Tranquilo', time: 'hace 21 minutos' },
  { name: 'Diana P.', city: 'Ibagué', product: 'MegaPack + Plan Maestro', time: 'hace 25 minutos' },
  { name: 'Sebastián L.', city: 'Santa Marta', product: 'MegaPack Colon Tranquilo', time: 'hace 28 minutos' },
];
